import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component'
import { SignupFormComponent } from './signup-form/signup-form.component';
import { PaymentsComponent } from './payments/payments.component';
import { CorporateSignupComponent } from './corporate-signup/corporate-signup.component'
import { CorporatepaymentComponent } from './corporatepayment/corporatepayment.component'
import { DraftGigComponent } from './draft-gig/draft-gig.component';
import { DraftCorporateComponent } from './draft-corporate/draft-corporate.component';
import { GenericSignupFormComponent } from './generic-signup-form/generic-signup-form.component';
import { GenericCorporateSignupComponent } from './generic-corporate-signup/generic-corporate-signup.component';
import { NhlaaCorporateSignupComponent } from './nhlaa-corporate-signup/nhlaa-corporate-signup.component';


const routes: Routes = [
  // gig
  { path: ':formLink', component: SignupFormComponent, pathMatch: 'full' },
  { path: 'viking/:formLink', component: GenericSignupFormComponent, pathMatch: 'full' },
  { path: 'nhlaa/corporate/:formLink/:tierId', component: GenericSignupFormComponent, pathMatch: 'full' },
  // { path: 'nhla/corporate/:formLink/:tierId', component: GenericSignupFormComponent, pathMatch: 'full' },
  { path: 'payment/form', component: PaymentsComponent },
  
  // corporate
  { path: 'corporate/:formLink', component: CorporateSignupComponent },
  { path: 'corporate/:formLink/:tierId', component: CorporateSignupComponent },
  { path: 'corporate/:formLink/:tierId/:employeeLink', component: CorporateSignupComponent },
  { path: 'generic-corporate/:formLink/:tierId/:employeeLink', component: GenericCorporateSignupComponent },
  { path: 'generic-corporate/:formLink/:tierId', component: GenericCorporateSignupComponent },
  { path: 'generic-corporate/:formLink', component: GenericCorporateSignupComponent },
  { path: 'payment/corporate', component: CorporatepaymentComponent },
  
  // draft - gig
  { path: 'draft/:formLink', component: DraftGigComponent },

  // draft - corporate
  { path: 'draft/corporate/:formLink', component: DraftCorporateComponent },
  { path: 'draft/corporate/:formLink/:tierId', component: DraftCorporateComponent },
  { path: 'draft/corporate/:formLink/:tierId/:employeeLink', component: DraftCorporateComponent },

  { path: 'header', component: HeaderComponent },
  { path: 'footer', component: FooterComponent },
  { path: '**', component: PagenotfoundComponent },
  { path: 'error', component: PagenotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



